import { Component, Input } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { PortfolioSnapshot } from '../../../domain/corporate/portfolio-snapshot';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
   selector: 'app-portfolio-snapshot-card',
   standalone: true,
   imports: [CommonModule, CurrencyPipe, SkeletonModule],
   templateUrl: './portfolio-snapshot-card.component.html',
   styleUrls: ['./portfolio-snapshot-card.component.scss']
})
export class PortfolioSnapshotCardComponent {
   @Input() snapshot: PortfolioSnapshot | null = null;
   @Input() loading: boolean = false;
   @Input() errorStatus: number | null = null;

   // Leave provision (API doesn't provide yet)
   @Input() highRiskHotelsCount: number | null = null;
   @Input() highRiskReportsCount: number | null = null;

   formatDate(isoDate: string | null | undefined): string {
      if (!isoDate) return '-';
      const parts = isoDate.split('-');
      if (parts.length !== 3) return isoDate;
      const [yyyy, mm, dd] = parts;
      return `${dd}/${mm}/${yyyy}`;
   }

   get showEmptyState(): boolean {
      return !this.loading && !this.snapshot;
   }
}
